import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../Buttons/Button";

const Alert = ({
  isOpen,
  onClose,
  title = "Alert",
  description = "",
  buttonCenter = false,
  cancelButton = {
    show: true,
    title: "Cancel",
    onClick: () => {},
  },
  acceptButton = {
    show: true,
    title: "Accept",
    onClick: () => {},
  },
  zIndex = 60,
  closeOnOutsideClick = false,
}) => {
  const handleBackdropClick = (e) => {
    if (closeOnOutsideClick) {
      onClose();
    }
  };
  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <div className="fixed inset-0 overflow-y-auto" style={{ zIndex }}>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-[#000000]/70 bg-opacity-70 transition-opacity"
            onClick={handleBackdropClick}
          />

          {/* Alert Dialog */}
          <div className="flex min-h-screen items-center justify-center p-4">
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 40,
              }}
              className="w-full max-w-md bg-white rounded-lg shadow-xl relative"
            >
              {/* Content */}
              <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  {title}
                </h2>
                <p className="text-gray-600">{description}</p>
              </div>

              {/* Actions */}
              <div
                className={`flex items-center  gap-3 p-4 border-t ${
                  buttonCenter ? "justify-center" : "justify-end"
                }`}
              >
                {cancelButton.show && (
                  <Button
                    title={cancelButton.title}
                    variant="text"
                    color="black"
                    onClick={() => {
                      cancelButton.onClick();
                      onClose();
                    }}
                  />
                )}
                {acceptButton.show && (
                  <Button
                    title={acceptButton.title}
                    onClick={() => {
                      acceptButton.onClick();
                      onClose();
                    }}
                  />
                )}
              </div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Alert;
